const MemberTermsList = `query getMemberTerms($username: String!){
  getMemberTerms(username: $username){
    teamTermMemberId
    completed
    applyNextTerm
    note
    noteUpdateBy
    noteUpdateDate
    teamTermId{
      termId{
        termId
        termUuid
        name
        startDate
        endDate
      }
      teamId{
        teamUuid
        name
      }
    }
    roleId{
      roleName
    }
  }
}`;

const MemberTermAttendanceList = `query getMemberTermAttendance($teamTermMemberId: Int!){
  getMemberTermAttendance(teamTermMemberId: $teamTermMemberId){
    teamTermResourceAttendanceId
    teamTermMemberId {
      teamTermMemberId
    }
    teamTermEventId {
      teamTermEventId
      teamTermPeriodId {
        teamTermPeriodId
        name
      }
      eventTypeId {
        eventTypeId
        name
      }
      name
      desc
      scheduledDate
      actualDate
      attendanceRequired
    }
    attended
  }
}`;

const MemberTermEventAttendance = `
query getMemberTermEventAttendance(
  $teamTermMemberId: Int! 
  $teamTermEventId: Int!
){
    getMemberTermEventAttendance(
      teamTermMemberId: $teamTermMemberId,
      teamTermEventId: $teamTermEventId
    ){
      teamTermResourceAttendanceId
      teamTermMemberId {
        teamTermMemberId
      }
      teamTermEventId {
        teamTermEventId
        teamTermPeriodId {
          teamTermPeriodId
          name
        }
        eventTypeId {
          eventTypeId
          name
        }
        name
        desc
        scheduledDate
        actualDate
        attendanceRequired
      }
      attended
  }
}`;

const EditTeamTermMemberAttendance_mutate = `
  mutation editTeamTermMemberAttendance(
    $teamTermResourceAttendanceId:Int!
    
    $attended: Boolean
  ){
    editTeamTermMemberAttendance(
      teamTermResourceAttendanceId: $teamTermResourceAttendanceId,
      
      attended: $attended,      
    ){
      teamTermResourceAttendance{
        teamTermResourceAttendanceId
        teamTermEventId{
          teamTermEventId
        }
        teamTermMemberId{
          teamTermMemberId
        }
        attended
      }
    }
  }
`;

const CreateOnboardedMember_mutate = `
  mutation createOnboardedMember(
    $email: String!,
    $firstName: String!, 
    $lastName: String!,
    $phoneNo: String!,
    $city: String!,
    $state: String!, 
    $country: String!,
    $linkedinUrl: String!,
    $termId: Int!) {
    createOnboardedMember(
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      phoneNo: $phoneNo,
      city: $city,
      state: $state,
      country: $country,
      linkedinUrl: $linkedinUrl,
      termId: $termId) {
      userId
      applicantId
      email      
      firstName
      lastName
      phoneNo
      city
      state
      country
      termId
    }
  }
`;

const ActivateOnboardedMember_mutate = `
    mutation activateOnboardedMember( $password: String!,
                                      $activationCode: String!) {
      activateOnboardedMember(password: $password,
                              activationCode: $activationCode) {
        userId
       activationCode
      }
    }
`;

const GetAllTermApplicantsByuserUuidClientId = 
`query getAllTermApplicantsByuserUuidClientId(
  $userUuid: String!, $clientId: Int!
  ){
  getAllTermApplicantsByuserUuidClientId(
    userUuid: $userUuid
    clientId: $clientId
  ){
    termId{
      termId
      termUuid
      name
      startDate
      endDate
    }
    teamTermMember
    {
      teamTermMemberId
      roleId
      {
        roleName
      }      
      completed
      applyNextTerm
      note
      noteUpdateBy
      noteUpdateDate
      teamTermId
      {
        teamId
        {
          teamUuid
          name
        }
      }
    }    
  }
}
`;

const GetMemberDashboardInfo = 
`query getMemberDashboardInfo(
  $clientId: Int!, $email: String!
  ){
  getMemberDashboardInfo(
    clientId: $clientId
    email: $email
  ){
    term
    {
      termId
      termUuid
      name
      startDate
      endDate
      noOfSeats
    }
    currentTermMember
    teamTermMembers
    {
      roleId
      {
        roleName
      }
      completed
      applyNextTerm
      teamTermId
      {
        teamTermId
        teamId
        {
          teamId
          name
          desc
        }
        noOfResources
        noOfMemberResources
        noOfStaffResources
      }
    }    
  }
}
`;

module.exports = {
  MEMBER_TERMS_LIST: MemberTermsList,
  MEMBER_TERM_ATTENDANCE_LIST: MemberTermAttendanceList,
  MEMBER_TERM_EVENT_ATTENDANCE: MemberTermEventAttendance,
  EDIT_TEAM_TERM_MEMBER_ATTENDANCE_MUTATION: EditTeamTermMemberAttendance_mutate,
  CREATE_ONBOARDED_MEMBER_MUTATION: CreateOnboardedMember_mutate,
  ACTIVATE_ONBOARDED_MEMBER_MUTATION: ActivateOnboardedMember_mutate,
  ALL_APPLICANT_TERMS_BY_USERUUID_CLIENTID: GetAllTermApplicantsByuserUuidClientId,
  GET_MEMBER_DASHBOARD_INFO: GetMemberDashboardInfo,
};
